import React from 'react'
import Breadcrub from '../Common/Breadcrub'
import { Link } from 'react-router-dom'

const Careers = () => {
  return (
    <>
      <Breadcrub title="Careers"  />
        <section class="aboutus-style-01">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-12">
                        <div class="row g-0 event-wrapper">                           
                            <div class="col-md-12">
                                <div class="p-1-3 p-sm-1-9">
                                    <p>We offer an extensive variety of career choices. We can keep you satisfied with challenging responsibilities, professional development and the opportunity to work with the best in the industry.</p>
                                    <p>At MGIMS, we will value your ideals, reward your achievements and encourage your pioneering spirit. If you are interested in exploring opportunities at MGIMS, write us at <Link to={'mailto:mgimedicalsciences@gmail.com'}>mgimedicalsciences@gmail.com</Link></p>                             
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Careers
